import { Stack, Text, useMantineTheme } from '@mantine/core'
import { TFunction } from 'i18next'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

const getPremiumUsernameText = (t: TFunction, renewal: boolean) => ({
  premiumLabel: renewal
    ? ''
    : t(
        'components.identity.premiumUserLabelRenewal',
        "Type in a Premium Username you'd like to renew"
      ),
  premiumModalTitle: renewal
    ? t('components.identity.premiumUserModalTitleRenewal', 'Renew Premium Username')
    : t('components.identity.premiumUserModalTitle', 'Purchase Premium Username'),
  premiumTitleArea: renewal
    ? t('components.identity.premiumUserTitleAreaRenewal', 'Renew Premium Username')
    : t('components.identity.premiumUserTitleArea', 'Purchase Premium Username'),
  premiumCheckAvailabilityButtonText: renewal
    ? t('components.identity.premiumUserAvailabilityBtnRenewal', 'Renew')
    : t('components.identity.premiumUserAvailabilityBtn', 'Check Availability & Cost'),
})

export function usePremiumUsernameText(renewal: boolean) {
  const { t } = useTranslation()
  return getPremiumUsernameText(t, renewal)
}

interface PremiumDetailsProps {
  detailsBox: any
  details: any
  minBalance: number | undefined
  displayBalance: string
  enoughBalance: boolean
}
export const PremiumDetails: React.FC<PremiumDetailsProps> = ({
  detailsBox,
  details,
  minBalance,
  displayBalance,
  enoughBalance,
}) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  return (
    <Stack className={detailsBox}>
      <Text className={details}>
        {t('common.cost', 'Cost')}: <b>{minBalance ? minBalance.toFixed(2) : '-'} L1</b>
      </Text>
      <Text
        className={details}
        style={{
          color: !enoughBalance ? theme.colors.notification[0] : theme.colors.textAndIcon[0],
        }}
      >
        {t('common.balance', 'Balance')}: <b>{displayBalance} L1</b>
      </Text>
    </Stack>
  )
}

interface PremiumTextAreaProps {
  className: any
  renewal: boolean
}
export const PremiumTextArea: React.FC<PremiumTextAreaProps> = ({ className, renewal }) => (
  <Text className={className}>
    {renewal ? (
      <Trans i18nKey="components.identity.premiumUserTextAreaRenewal">
        Renew your Premium Username for one more year.
        <br />
      </Trans>
    ) : (
      <Trans i18nKey="components.identity.premiumUserTextArea">
        Secure your unique username on LAMINA1. Premium Usernames have no number hash attached and
        are totally unique to you. <br />
        <b>Premium Usernames require an annual fee.</b>
        <br />
        You can view your usernames and manage renewals in your Profile.
        <br />
        For more details, see:
        <br />
        <a href="/helpcenter/Usernames" rel="noreferrer" target="_blank">
          What is a Premium Username? Why get one?
        </a>
      </Trans>
    )}
  </Text>
)
